import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "g-label-column-rows" }

import provideGetChartRows from "../provider/provideGetChartRows"
import provideConfig from "../provider/provideConfig"


export default /*#__PURE__*/_defineComponent({
  __name: 'GGanttLabelColumn',
  setup(__props) {

const { font, colors, labelColumnTitle, rowHeight } = provideConfig()
const getChartRows = provideGetChartRows()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "g-label-column",
    style: _normalizeStyle({ fontFamily: _unref(font), color: _unref(colors).text })
  }, [
    _renderSlot(_ctx.$slots, "label-column-title", {}, () => [
      _createElementVNode("div", {
        class: "g-label-column-header",
        style: _normalizeStyle({ background: _unref(colors).primary })
      }, _toDisplayString(_unref(labelColumnTitle)), 5)
    ]),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getChartRows)(), ({ label }, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `${label}_${index}`,
          class: "g-label-column-row",
          style: _normalizeStyle({
          background: index % 2 === 0 ? _unref(colors).ternary : _unref(colors).quartenary,
          height: `${_unref(rowHeight) + 6}px`
        })
        }, [
          _renderSlot(_ctx.$slots, "label-column-row", { label: label }, () => [
            _createElementVNode("span", null, _toDisplayString(label), 1)
          ])
        ], 4))
      }), 128))
    ])
  ], 4))
}
}

})